<template>
  <!-- 产品 -->
  <div
    class="list-card simple-click-hover list-edit-parent"
    @click="openProductDetail"
    v-if="type === 'prod'"
    :style="cardStyle"
  >
    <!-- 产品主图 -->
    <div class="img-body">
      <prod-icon :src="data.ProdLogo" :width="165" :height="165"></prod-icon>
    </div>
    <!-- 是否推广 -->
    <!-- <div class="popularize-sign" v-if="data.AdvertPosition">推广</div> -->
    <div class="card-info">
      <!-- 产品详情(产品名称、浏览/下载量) -->
      <div class="card-mid">
        <p class="text-clamp2" :title="getTextWithRegex(data.ProdName)" v-html="stringFilter(data.ProdName)"></p>
      </div>
      <div class="card-num text-clamp1" v-if="data.ViewNums !== undefined || data.DownNums !== undefined">
        <span style="margin-right: 10px">浏览{{ data.ViewNums || 0 }}</span>
        <span>下载{{ data.DownNums || 0 }}</span>
      </div>
      <div class="card-btm-empty" v-if="showComp"></div>
      <router-link :to="`/company/home/${data.CompID || data.CompId}`" :target="OpenService.getRouterTarget()" class="card-btm" v-if="showComp">
        <!-- 金牌/银牌/铜牌/无 + 公司名称-->
        <div class="auth-type" @click.stop="">
          <vip-level :curData="data" :width="16"></vip-level>
          <span v-html="stringFilter(data.CompName || data.PromoteName)"></span>
        </div>
      </router-link>
    </div>
    <slot name="footer"></slot>
  </div>

  <!-- 公司 -->
  <router-link
    :to="`/company/home/${data.CompID || data.CompId}`"
    :target="OpenService.getRouterTarget()"
    class="list-card simple-click-hover"
    v-else
    @mouseover.native="_cardMouseover"
    @mouseout.native="_cardMouseout"
  >
    <!-- 公司logo -->
    <div class="img-body">
      <comp-icon
        :src="data.CompLogo"
        :width="165"
        :height="165"
      ></comp-icon>
    </div>

    <div class="card-info">
      <!-- 公司详情 -->
      <div class="card-mid" style="padding-bottom: 5px;">
        <p class="text-clamp2" v-html="stringFilter(data.CompName)"></p>
      </div>
    </div>

    <div class="card-btm-empty" v-if="data.Province || data.City"></div>
    <div class="card-btm" v-if="data.Province || data.City">
      <div class="auth-type" style="background: transparent;justify-content: space-between">
        <span>{{data.Province}}{{data.City !== data.Province ? data.City : ''}}</span>
        <vip-level-icon :curData="data"></vip-level-icon>
      </div>
    </div>

    <slot name="footer"></slot>
  </router-link>
</template>

<script>
import {AdvertsService} from '@digital-supply-chain/module'
import { OpenService } from "@/service";
import ProdIcon from "/@/components/icon/prod-icon.vue";
import CompIcon from "/@/components/icon/comp-icon.vue";
import VipLevelIcon from "/@/components/icon/vip-level-icon.vue";
import VipLevel from "/@/components/icon/vip-level.vue";

export default {
  components: {
    ProdIcon,
    CompIcon,
    VipLevelIcon,
    VipLevel,
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {};
      },
    },
    type: {
      type: String,
      default: "prod",
    },
    cardStyle: { dafault: {} },
    /**产品类别时是否显示底部企业信息 */
    showComp: { default: true },
  },
  data() {
    return {
      OpenService
    };
  },
  methods: {
    stringFilter(value) {
      return value ? value.toString() : value;
    },
    _cardMouseover(e) {
      this.$emit('mouseover', e);
    },
    _cardMouseout(e) {
      this.$emit('mouseout', e);
    },
    openProductDetail() {
      if (this.data.AdvId) {
        AdvertsService.clickAdverts(this.data.AdvId);
      }
      OpenService.openProdDetails(this.data.ProdID || this.data.ProdId);
    },
    getTextWithRegex(html) {
      return html ?  html.toString().replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() : html;
    }
  },
};
</script>

<style lang="less" scoped>
// 产品卡片
.list-card {
  position: relative;
  border: 1px solid #d6d6d6;
  font-size: 0;
  min-width: 150px;
  max-width: 180px;
  margin: 0 5px 10px 5px;
  flex: 1;
  text-decoration: none;
  background: #ffffff;
  display: block;
  .img-body{
    padding: 3px;
    align-items: center;
    justify-content: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 150px;
    overflow: hidden;
    img{
      object-fit: contain;
      max-width: 100%;
    }
  }
}

.card-info {
  background: #ffffff;
}

.card-mid {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 37px;
  padding: 5px 5px 0;
  // 产品名称
  p {
    overflow: hidden;
    font-size: 14px;
    color: #111a2a;
    margin: 0;
  }
  /deep/ em{
    font-style: initial;
    color: #dc0000;
  }
}

// 浏览/下载
.card-num {
  margin-bottom: 5px;
  margin-top: 6px;
  font-size: 12px;
  color: #9f9e9e;
  padding: 0 5px;
}

.card-btm-empty{
  width: 100%;
  height: 28px;
}
.card-btm {
  text-decoration: none;
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  // 金/银/铜 + 公司名称
  .auth-type {
    display: flex;
    align-items: center;
    height: 28px;
    padding: 0 2px;
    background: @content-bg;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
      color: @text-color-call-out;
    }
    /deep/ em{
      font-style: initial;
      color: #dc0000;
    }
    /deep/ .vip-level{
      margin-right: 4px;
    }
  }
}
.popularize-sign{
  width: 30px;
  height: 18px;
  background: rgba(51, 51, 51, 0.6);
  opacity: 0.67;
  font-size: 10px;
  color: #fff;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  line-height: 18px;
}
</style>
